import Model from '@/models/Model.js';

export default class Gradebook extends Model {
    static entity = 'gradebooks';

    static modelName = 'Gradebook';

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
            grades: this.hasMany('gradebook_grades', 'gradebook_id'),
        };
    }
}
